import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportationTrackingComponent } from './transportation-tracking.component';
import { TranslateModule } from '@ngx-translate/core';
import { InfoFieldModule } from '../info-field/info-field.module';
import { TimezoneModule } from '../timezone/timezone.module';
import { DatesWithDividerModule } from '../dates-with-divider/dates-with-divider.module';
import { MaterialModule } from '../../material.module';
import { TransportationTrackingDatesDialogComponent } from './dates-dialog/transportation-tracking-dates-dialog.component';
import { ActionButtonModule } from '../action-button';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [TransportationTrackingComponent, TransportationTrackingDatesDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    InfoFieldModule,
    TimezoneModule,
    DatesWithDividerModule,
    MaterialModule,
    ActionButtonModule,
    SvgIconModule,
  ],
  exports: [TransportationTrackingComponent, TransportationTrackingDatesDialogComponent],
})
export class TransportationTrackingModule {}
